<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_TELLER'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button mat-raised-button color="warn" (click)="deleteTeller()" *LOSxHasPermission="'DELETE_TELLER'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Teller Name' | translate }}
        </div>

        <div class="flex-50">
          {{ tellerData.name }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Office' | translate }}
        </div>

        <div class="flex-50">
          {{ tellerData.officeName }}
        </div>

        @if (tellerData.description) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Description' | translate }}
          </div>
        }

        @if (tellerData.description) {
          <div class="flex-50">
            {{ tellerData.description }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Start Date' | translate }}
        </div>

        <div class="flex-50">
          {{ tellerData.startDate | dateFormat }}
        </div>

        @if (tellerData.endDate) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.End Date' | translate }}
          </div>
        }

        @if (tellerData.endDate) {
          <div class="flex-50">
            {{ tellerData.endDate | dateFormat }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Status' | translate }}
        </div>

        <div class="flex-50">
          {{ tellerData.status | titlecase }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
